angular.module('iw.frontyard.equal_repayment_calculator', [
    'iw.frontyard.app',
    'iw.frontyard.math',
    'iw.frontyard.translate',
    'iw.frontyard.string',
    'iw.frontyard.repayment_calculator',
    'ui.slider',
    'iw.frontyard.common',
]);



